import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { getSystemHealth } from "../../../services/tenantUserAdminService";
import { TC } from "../../../tokens/text";

export default function SystemHealthWidget({ tenantId }) {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState({});

  useEffect(() => {
    const demoMode = typeof window !== 'undefined' && (window.__LEDGERHUB_DEMO || new URLSearchParams(window.location.search).get('demo') === 'true');
    if (demoMode) {
      setStatus({ reachable: true, recentErrors: [] });
      setLoading(false);
      return;
    }
    setLoading(true);
    // System health is tenant-agnostic but accept tenantId to keep signature consistent
    getSystemHealth(tenantId)
      .then((res) => setStatus(res || {}))
      .catch(() => setStatus({ reachable: false }))
      .finally(() => setLoading(false));
  }, [tenantId]);

  if (loading) return <VuiBox display="flex" justifyContent="center" alignItems="center" height="100%"><CircularProgress size={20} /></VuiBox>;

  return (
    <VuiBox display="flex" alignItems="center" justifyContent="space-between" px={2}>
      <VuiTypography sx={{ color: status.reachable ? "#4caf50" : "#f44336", fontWeight: 700 }}>
        {status.reachable ? "Backend OK" : "Backend unreachable"}
      </VuiTypography>
      <VuiTypography sx={{ color: TC.secondary }}>{status.recentErrors ? `${status.recentErrors.length} recent errors` : "No recent errors"}</VuiTypography>
    </VuiBox>
  );
}

